const trackEvent = function(category, action, label, value) {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  })
}

export { trackEvent }
